import { AsgardDocPdf } from 'src/app/core/documents/asgard-doc-pdf';
import { Injectable, NgZone } from '@angular/core';
import { TtsService } from '../speech/tts.service';
import { ReadingBoundary } from '../../core/reading-utils/enums';
import { AsgardDocBase } from 'src/app/core/documents/asgard-doc-base';
import { DocumentManagerService } from './document-manager.service';
import { DocumentHighlightService } from './document-highlight.service';
import { ReadingService } from '../text/reading.service';
import { ReadingActions } from 'src/app/core/enums';

@Injectable({
    providedIn: 'root'
})
export class DocumentScrollingService {
    private showedDocRect: {x1: number, y1: number, x2: number, y2: number} | null = null;

    private get currentDoc(): AsgardDocBase | null | undefined { return this.docMgrService.currentDoc; }

    constructor(
        private readonly ttsService: TtsService,
        private readonly docMgrService: DocumentManagerService,
        private readonly docHighlight: DocumentHighlightService,
        private readonly readingService: ReadingService,
        private readonly ngZone: NgZone,
    ) {
        this.initSubscriptions();
    }

    updateShowedPageRect() {
        if(this.currentDoc){
            this.showedDocRect = this.currentDoc.getShowedDocRect();
        }
    }

    private initSubscriptions() {
        this.docMgrService.documentReady.subscribe(() => {
            if (this.currentDoc !== null) {
                this.updateShowedPageRect();
            }
        });

        this.ttsService.readingPosition.subscribe(async msg => {
            if (msg === null) {
                return;
            }

            if (msg.boundaryType === ReadingBoundary.Word && this.currentDoc && this.currentDoc.hasReadingItem && this.currentDoc.readingItem) {
                const word = this.currentDoc.readingItem.find(x => x.itemIdx === msg.wordIdx);

                if (word) {
                    if (this.currentDoc instanceof AsgardDocPdf && word.pageIdx !== this.currentDoc.getCurrentPageIdx()) {
                        this.ngZone.run(() => this.readingService.runAction(ReadingActions.Stop));
                        this.docHighlight.cleanCurrentHighlight(true);
                        this.updateShowedPageRect();
                        return;
                    }

                    if (!this.showedDocRect || !word.boundary) {
                        this.currentDoc.scrollToWord(word);
                        this.updateShowedPageRect();
                    } else {
                        const { x1, y1, x2, y2 } = this.showedDocRect;
                        const { x, y, width, height } = word.boundary;

                        if (!(x >= x1 && x + width <= x2) || !(y >= y1 && y + height <= y2)) {
                            this.currentDoc.scrollToWord(word);
                            this.updateShowedPageRect();
                        }
                    }
                }
            }
        });
    }
}
